<template>
  <div>
    <VerifyIdentityError
      v-if="availableMfaModalities.length === 0"
      class="md:w-480 md:mx-auto"
      :cancelText="$t('common.back_btn')"
      :errorTitle="$t('common.no_contact_info_found')"
      :errorBody="coalescedSupportText('common.contact_health_plan_csr.help')"
      @cancel="onCancel"
    />
    <ModalitySelect
      v-else
      :canCancel="true"
      :errorText="errorText"
      :helperText="
        coalescedSupportText(
          'common.contact_health_plan_csr.contact_info_change'
        )
      "
      :mfaPreference="mfaType"
      :availableMfaModalities="availableMfaModalities"
      :isBusy="isBusy"
      @continue="onMfaSelect"
      @cancel="onCancel"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { ModalitySelect, VerifyIdentityError } from '@components/common/mfa'
import supportMixin from '@components/mixins/support'

export default {
  components: {
    ModalitySelect,
    VerifyIdentityError,
  },
  mixins: [supportMixin],
  data() {
    return {
      errorText: '',
      isBusy: false,
    }
  },
  computed: {
    ...mapGetters('member', ['availableMfaModalities', 'mfaType']),
  },
  methods: {
    ...mapActions('member', ['updateMfaPreference']),
    onCancel() {
      this.$emit('cancel')
    },
    onMfaSelect(mfaPreference) {
      this.isBusy = true
      this.updateMfaPreference(mfaPreference)
        .then(() => {
          this.isBusy = false
          this.$emit('continue')
        })
        .catch((error) => {
          this.isBusy = false
          this.errorText = error.json.message
        })
    },
  },
}
</script>
